import React, { useMemo } from 'react';
import { Gantt } from 'gantt-task-react';
import 'gantt-task-react/dist/index.css';
import WidgetShell from '../../../../../ui/WidgetShell';
import { usePlanner } from '../../../contexts/PlannerContext';
import useMediaQuery from '../../../../../hooks/useMediaQuery.js';

export default function GanttView() {
  const { tasks = [] } = usePlanner();
  const isMobile = useMediaQuery('(max-width: 640px)');

  const ganttTasks = useMemo(() => {
    return tasks
      .filter((t) => t?.start || t?.startDate || t?.dueDate || t?.end)
      .map((t) => ({
        id: String(t.id),
        name: t.title || 'Untitled task',
        start: new Date(t.start || t.startDate || t.dueDate || t.end),
        end: new Date(t.end || t.dueDate || t.start || t.startDate || new Date()),
        type: 'task',
        styles: {
          backgroundColor: 'var(--mudo-primary)',
          progressColor: 'var(--mudo-primary-soft)',
          backgroundSelectedColor: 'var(--mudo-primary)',
          progressSelectedColor: 'var(--mudo-primary-soft)',
          color: 'var(--mudo-text)',
        },
      }));
  }, [tasks]);

  return (
    <WidgetShell title="Timeline (Gantt)">
      <div className="border border-[var(--mudo-border)] rounded-xl bg-[var(--mudo-bg-soft)]/80 backdrop-blur p-2 text-[var(--mudo-text)]">
        <Gantt
          tasks={ganttTasks}
          viewMode={isMobile ? "Week" : "Day"}
          listCellWidth="180px"
          todayColor="var(--mudo-primary-soft)"
        />
      </div>
    </WidgetShell>
  );
}
